export default __webpack_public_path__ + "static/media/Lora-Italic.80a154f9.ttf";